import { render } from "./ExportDropdown.vue?vue&type=template&id=563a17c0&scoped=true&ts=true"
import script from "./ExportDropdown.vue?vue&type=script&lang=ts"
export * from "./ExportDropdown.vue?vue&type=script&lang=ts"

import "./ExportDropdown.vue?vue&type=style&index=0&id=563a17c0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563a17c0"]])

export default __exports__